module.exports = __webpack_public_path__ + "static/media/app.b2db8677.svg";